import {
  DiagramGeneralSettings,
  ActivityType,
  ActivitySettings,
  FlowlineSettings
} from '../diagram-type-styles.model';
import {DiagramTypes as DiagramReportTypes} from '@q9elements/ui-kit/common';
import {UPNBaseConfig} from './diagram-upn-base-config';

export class WhiteboardConfig extends UPNBaseConfig {
  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.WHITEBOARD_DEFAULT_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v2',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    }
  ];

  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      canAutoGenerateDrilldown: false,
      canAddAttribute: false,
      canGenerateStoriesAI: false,
      canGenerateRequirements: false,
      tagName: 'Whiteboard',
      tagColor: '#F39C20',
      disableVersioning: true,
      disableResources: true,
      disableSubtypeChange: true,
      enabledReportTypes: [
        DiagramReportTypes.ActivityAttachment,
        DiagramReportTypes.ActivityCapturedStories,
        DiagramReportTypes.ActivityList,
        DiagramReportTypes.ActivityReferenceModel,
        DiagramReportTypes.DataStructure,
        DiagramReportTypes.DiagramComments,
        DiagramReportTypes.StickyNote
      ]
    };
  }

  activitySettings(x?: number, y?: number): ActivitySettings {
    return {
      ...super.activitySettings(x, y),
      text: 'Text'
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    const baseSettings = super.flowlineSettings(x, y, id);

    return {
      ...baseSettings,
      config: {
        ...baseSettings.config,
        text: ''
      }
    };
  }
}
